import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const Videos = ({ contents, subCategory, language, buttonText }) => {
  // Animation variants for staggered cards
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };

  const cardVariants = {
    hidden: { 
      opacity: 0, 
      y: 30,
      scale: 0.95
    },
    visible: { 
      opacity: 1, 
      y: 0,
      scale: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut"
      }
    }
  };

  const buttonVariants = {
    hover: { 
      scale: 1.05,
      transition: { duration: 0.2 }
    },
    tap: { 
      scale: 0.95,
      transition: { duration: 0.1 }
    }
  };

  const imageVariants = {
    hover: { 
      scale: 1.05,
      transition: { duration: 0.3 }
    }
  };

  return (
    <>
      <section className='font-ubuntu mb-5'>
        <motion.div 
          className='flex justify-between pt-4 mb-2'
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          <h1 className='text-[#2d95a5] font-bold text-2xl md:text-3xl'>
            {/* Yoga Videos */}
          </h1>
          {/* <button className='bg-[#2d95a5] hover:bg-[#91c8d0] text-white font-bold py-2 px-4 rounded-full text-xs lg:text-md md:mt-0'>
            View all
          </button> */}
        </motion.div>

        <div className='flex flex-col justify-center'>
          <motion.div 
            className='grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-3'
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            {contents
              ?.filter((content) => {
                const languageMatch =
                  language.id === 0 || content.language_id === language.id;
                const subCategoryMatch =
                  subCategory.id === 0 ||
                  content.content_subcategory_id === subCategory.id;
                return languageMatch && subCategoryMatch;
              })
              ?.map((content, index) => (
                <motion.div
                  key={index}
                  className='bg-white border rounded-xl shadow-sm hover:shadow-lg transition-shadow duration-300'
                  variants={cardVariants}
                  whileHover={{ 
                    y: -5,
                    transition: { duration: 0.3 }
                  }}
                >
                  {/* <div className="border border-[#2d95a5] m-3 rounded-lg overflow-hidden">
                  <img
                    crossOrigin="anonymous"
                    className="object-contain w-full h-48"
                    src={`${process.env.REACT_APP_BASE_FILE_URL}/${content.thumbnail}`}
                    alt={`Card ${index + 1}`}
                  />
                </div> */}

                  <motion.div 
                    className='m-3 overflow-hidden rounded-sm'
                    variants={imageVariants}
                    whileHover="hover"
                  >
                    <img
                      crossOrigin="anonymous"
                      className='object-contain w-full'
                      src={content.thumbnail}
                      alt={`Card ${index + 1}`}
                    />
                  </motion.div>
                  
                  <div className='px-2 text-[#2d95a5]'>
                    <motion.div 
                      className='text-base font-bold'
                      whileHover={{ color: "#1e4a52" }}
                      transition={{ duration: 0.2 }}
                    >
                      <Link to={`/details/${content.id}`}>
                        {" "}
                        {content.title}
                      </Link>
                    </motion.div>
                  </div>

                  <div className='flex items-center justify-between px-2 py-4'>
                    <motion.div 
                      className='text-xs font-normal text-gray-600'
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ delay: 0.3 + index * 0.1 }}
                    >
                      {moment(content.createdAt).format("LL")}
                    </motion.div>

                    <div className=''>
                      <motion.div
                        variants={buttonVariants}
                        whileHover="hover"
                        whileTap="tap"
                      >
                        <Link
                          to={`/details/${content.id}`}
                          className='border-2 border-[#2d95a5] hover:bg-[#2d95a5] hover:text-white font-bold py-2 px-4 text-sm rounded-full transition-colors duration-300'
                        >
                          {buttonText}
                        </Link>
                      </motion.div>
                    </div>
                  </div>
                </motion.div>
              ))}
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default Videos;
